import React, { useState, useEffect } from 'react';
import '../stylesheets/Header.css';
import { Button, Navbar } from 'react-bootstrap';
import { FiLogOut, FiSettings } from 'react-icons/fi';
import { withRouter } from 'react-router-dom';
import data from '../mockdata/settingMenu.json';
import { SettingContext } from '../context/SettingContext';
import { decode } from 'jsonwebtoken';
import SettingUpdateDialogue from './SettingUpdateDialogue';

const Header = (props) => {

    const { toggleSetting, showDialogue, closeDialogue, language, translatedContent } = React.useContext(SettingContext);

    const [selectedLang, setSelectedLang] = useState(localStorage.language);

    useEffect(() => {
        if (props.showOptions) {
            let decoded = decode(localStorage.getItem('tokens'));
            let formatDecode = (decoded.exp) * 1000;
            let currentTimeStamp = Date.now();

            if (formatDecode < currentTimeStamp) {
                props.logout();
            }
            else {
                return;
            }
        }
    });

    const langdata = data.map((data) => {
        return (
            <option key={data.id} value={data.language}>{props.isMobile ? data.code : data.language}</option>
        );
    });

    const handleChange = (event) => {
        setSelectedLang(event.target.value);
        toggleSetting(event.target.value, localStorage.currency ? localStorage.currency : 'Euro');
    };

    const handleRoute = (routeTo) => {
        props.history.push({ pathname: '/' + routeTo });
    };

    return (
        !showDialogue ?
            <Navbar bg="light" variant="light">
                <div>
                    {
                        props.showOptions ?
                            props.isMobile ?
                                <Button variant="primary" id="settingsButton"
                                    onClick={() => { handleRoute('config'); }}
                                ><FiSettings /></Button>
                                :
                                <Button variant="primary" id="settingsButton"
                                    onClick={() => { handleRoute('config'); }}
                                ><FiSettings />{' '}{translatedContent.Settings}</Button>
                            : null
                    }
                </div>
                <div className="mx-auto">
                    <Navbar.Brand href="/" id="NetsLogo">
                        <img
                            alt=""
                            // src="/logo 1.png"
                            // src={logo}
                            src={`${process.env.PUBLIC_URL}/assets/images/Logo 1.png`}
                            width="auto"
                            height="30"
                            className="d-inline-block align-top"
                        />{' '}
                        Paypoint
                    </Navbar.Brand>
                </div>
                <div className="logout-button-align">
                    {
                        props.showOptions ?
                            props.isMobile ?
                                <Button variant="secondary" id="logoutButton"
                                    onClick={props.logout}
                                ><FiLogOut style={{ verticalAlign: 'middle' }} /></Button>
                                :
                                <Button variant="secondary" id="logoutButton"
                                    onClick={props.logout}
                                ><FiLogOut />{' '}{translatedContent.Logout}</Button>
                            : <select className="custom-select" id="selectLanguage" value={selectedLang}
                                onChange={handleChange}
                            >
                                {langdata}
                            </select>
                    }
                </div>
            </Navbar>
            :
            <SettingUpdateDialogue show={showDialogue} language={language} closeDialogue={closeDialogue} />
    );
};
export default withRouter(Header);